import cx from 'clsx';
import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const AdditionalInfoSkeleton = () => {
  return (
    <div className={cx(style.blockContainer, style.skeletonContainer)}>
      <SkeletonBlock className={style.skeletonField} />
      <SkeletonBlock className={style.skeletonField} />
    </div>
  );
};

export default AdditionalInfoSkeleton;
